import type { JSX } from 'react'

import { ButtonFonts, ButtonCorners, ButtonIconSizes, IconPositions } from "/app/libraries/arcana/src/atoms/Button/index.ts"
import { ButtonGroupSubscriptionStatus } from "/app/libraries/arcana/src/blocks/ButtonGroup/Templates/index.ts"
import { IconNames } from "/app/libraries/arcana/src/atoms/Icon/index.ts"
import { INDENTS } from "/app/libraries/arcana/src/vars/index.ts"
import { LayoutBlockAuth } from "/app/libraries/arcana/src/blocks/LayoutBlock/Templates/index.ts"
import { PrimaryLoginButton, SecondaryFontButton1Button } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBlockAlignItems } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBlockSubscriptionStatus } from "/app/libraries/arcana/src/blocks/TextBlock/Templates/index.ts"
import { TextAligning, TextBoxColors } from "/app/libraries/arcana/src/atoms/TextBox/index.ts"
import { TextBoxMaxLine2Font2XlBold, TextBoxMaxLine2FontMdToSm } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import {
  changeCredentials,
  tryAgain,
  $header,
  $subject,
  $message,
  $pendingTryAgain,
} from '../model'

export function Title(): JSX.Element {
  const title = useUnit($header)
  return title ? (
    <AppTitle>{title}</AppTitle>
  ) : (
    <AppTitle t='expired_subscription' />
  )
}

SubscriptionStatusPage.displayName = 'SubscriptionStatusPage'
export function SubscriptionStatusPage(): JSX.Element {
  const { t } = useTranslation()

  const subject = useUnit($subject)
  const message = useUnit($message)

  const onChangeCredentials = useUnit(changeCredentials)
  const onTryAgain = useUnit(tryAgain)

  const pending = useUnit($pendingTryAgain)

  return (
    <LayoutBlockAuth>
      <TextBlockSubscriptionStatus alignItems={TextBlockAlignItems.Center}>
        <TextBoxMaxLine2Font2XlBold
          title={subject ?? ''}
          alignment={TextAligning.Center}
        />
        <TextBoxMaxLine2FontMdToSm
          title={message ?? ''}
          color={TextBoxColors.TEXT_ICON_SECONDARY}
          alignment={TextAligning.Center}
          maxLines={0}
          preWrap
        />
      </TextBlockSubscriptionStatus>
      <ButtonGroupSubscriptionStatus>
        <SecondaryFontButton1Button
          title={t('change_credentials_button')}
          corners={ButtonCorners.CORNERS_10}
          paddings={[INDENTS.INDENT_30]}
          onClick={onChangeCredentials}
          disabled={pending}
        />
        <PrimaryLoginButton
          title={t('try_again')}
          font={ButtonFonts.Button1}
          icon={pending ? undefined : IconNames.restart}
          iconPosition={IconPositions.Left}
          iconSize={ButtonIconSizes.sm}
          corners={ButtonCorners.CORNERS_10}
          paddings={[INDENTS.INDENT_30]}
          onClick={onTryAgain}
          disabled={pending}
          withLoader
          hideTitleOnLoading
          isLoading={pending}
        />
      </ButtonGroupSubscriptionStatus>
    </LayoutBlockAuth>
  )
}
